import React, { useState, useRef } from "react";
import "./Login.css";
import axios from "axios";
import "../../Global/Global.css";
import { useNavigate } from "react-router-dom";
import Images from "../../Assets/Images";
import { getFCMToken } from "../../requestNotificationPermission";

export default function Login() {
  const [isRegister, setIsRegister] = useState(false);
  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [otp, setOtp] = useState([]);
  const inputRefs = useRef([]);
  // const [registerData, setRegisterData] = useState({
  //   username: "",
  //   email: "",
  //   password: "",
  // });
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    const fcmToken = await getFCMToken();
    console.log({ first: fcmToken});
    try {
      const response = await axios.post(
        "https://q2h.in/q2h-api/api/login",
        { email: loginData.email, password: loginData.password, user_type: 3, device_token:fcmToken }
      );
      console.log("Login successful:", response);
      if (response.data[0].status === 200) {
        localStorage.setItem("token", response.data[0].access_token)
        localStorage.setItem("branch", response.data[0].data.branch)
        navigate("/");
      }
    } catch (error) {
      console.error(
        "Login failed:",
        error.response ? error.response.data : error.message
      );
      setError("Login failed. Please check your credentials.");
    }
  };



  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
    if (name === "email") {
      if (!validateEmail(value) && value.length > 0) {
        setError("Invalid email format");
      } else {
        setError("");
      }
    }
  };

  return (
    <div className="auth-container">
      <div className="left-box">
        {/* <div class="circle-big"></div>
        <div class="circle "></div> */}
      </div>

      <div className="right-box">
        <div className="login">
          <div className="logo-page">
            {/* <img src={Images.logo_bg} className="" /> */}
            <img src={Images.logo} className="" />
          </div>
          <div className="logo">
            <img src={Images.logo_bg} />
            {/* <img src={Images.logo} className="" /> */}
          </div>


          <div className="login-container">
            <h1 className="heading ">Wellcome !</h1>
            <h5 style={{ textAlign: "center", fontWeight: "bold" }}>
              Login to your Q2h
            </h5>
            <form onSubmit={handleLogin}>
              <input
                type="email"
                name="email"
                placeholder="Email"
                required
                value={loginData.email}
                onChange={handleChange}
                className="input-field"
              />
              <input
                type='password'
                name="password"
                placeholder="password"
                required
                value={loginData.password}
                onChange={handleChange}
                className="input-field"
              />
              {error && <p className="error-message">{error}</p>}
              <button type="submit" className="btn-login  mt-2" onClick={handleLogin}>
                Continue
              </button>

            </form>


          </div>

        </div>
      </div>
    </div>
  );
}
